import { helper } from "@ember/component/helper";
import type { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";

function changesetValidatesPresence([changeset, key]: [
  EmberChangeset,
  string
]) {
  const validations = changeset.validationMap ?? {};

  const validationsForKey = validations[key];

  if (!validationsForKey) return false;

  return Array.isArray(validationsForKey)
    ? validationsForKey.find(isPresenceValidation)
    : isPresenceValidation(validationsForKey);
}

// This function compares a function passed as first argument with the `validatePresence` from ember-changeset-validations
// To decide if these functions are the same, it uses the `toString()` representation of the functions
function isPresenceValidation(validation: () => void): boolean {
  return validation.toString() === validatePresence().toString();
}

export default helper(changesetValidatesPresence);
